import React, { useState, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PageTemplate from '../../components/Common/PageTemplate';
import { Search, Users, Award, Filter, Home, UserCheck, Mail, ExternalLink, FlaskConical, Microscope, Leaf, Fish, Globe, Dna } from 'lucide-react';

const BiologyFaculty = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSubDept, setSelectedSubDept] = useState('Tümü');
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      id: 'tanitim',
      name: 'Tanıtım',
      icon: <Home className="w-5 h-5" />,
      path: '/bolumler/biyoloji',
      isActive: location.pathname === '/bolumler/biyoloji'
    },
    {
      id: 'ogretim-uyeleri',
      name: 'Öğretim Üyeleri',
      icon: <UserCheck className="w-5 h-5" />,
      path: '/bolumler/biyoloji/ogretim-uyeleri',
      isActive: location.pathname === '/bolumler/biyoloji/ogretim-uyeleri'
    }
  ];

  // Biyoloji bölümü öğretim üyeleri verisi
  const biologyFaculty = [
    // Biyoteknoloji
    { name: "Nilüfer CİHANGİR", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Biyoteknoloji", is_president: true, avesis_url: "https://avesis.hacettepe.edu.tr/nil", photo_url: "https://fs.hacettepe.edu.tr/biology/resimler/Biyoteknoloji_personel/tn_NCihangir.jpg" },
    { name: "Işıl SEYİS BİLKAY", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Biyoteknoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/iseyis", photo_url: "https://fs.hacettepe.edu.tr/biology/resimler/Biyoteknoloji_personel/tn_ISeyis.jpg" },
    { name: "Neslihan İDİL", title: "Doç. Dr.", department: "Biyoloji", sub_department: "Biyoteknoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/nsurucu", photo_url: "https://fs.hacettepe.edu.tr/biology/resimler/Biyoteknoloji_personel/tn_NIdil.jpg" },
    { name: "Gözde KOŞARSOY AĞÇELİ", title: "Doç. Dr.", department: "Biyoloji", sub_department: "Biyoteknoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/gozdekosarsoy", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7868" },
    { name: "Yusuf Doruk ARACAGÖK", title: "Doç. Dr.", department: "Biyoloji", sub_department: "Biyoteknoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/doruk", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6884" },
    { name: "Sezen BİLEN ÖZYÜREK", title: "Doç. Dr.", department: "Biyoloji", sub_department: "Biyoteknoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/sbilen", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7525" },
    { name: "Nermin Hande AVCIOĞLU", title: "Doç. Dr.", department: "Biyoloji", sub_department: "Biyoteknoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/hurkmez", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7016" },
    { name: "Sinem DİKEN GÜR", title: "Dr.", department: "Biyoloji", sub_department: "Biyoteknoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/sinemdkn", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5890" },
    { name: "Gülcan ŞAHAL", title: "Dr.", department: "Biyoloji", sub_department: "Biyoteknoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/gozbakir", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7438" },
    
    // Botanik
    { name: "Emel OYBAK DÖNMEZ", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Botanik", is_president: true, avesis_url: "https://avesis.hacettepe.edu.tr/polen", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7362" },
    { name: "A. Ali DÖNMEZ", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Botanik", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/donmez", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6298" },
    { name: "Yasemin EKMEKÇİ", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Botanik", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/yase", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6210" },
    { name: "Nuran ÇİÇEK", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Botanik", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/ncicek", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5662" },
    { name: "Aslı ÖZKÖK SABAN", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Botanik", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/aozkok", photo_url: "https://avesis.hacettepe.edu.tr/user/image/10882" },
    { name: "Burcu TARIKAHYA HACIOĞLU", title: "Doç. Dr.", department: "Biyoloji", sub_department: "Botanik", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/btarikah", photo_url: "https://avesis.hacettepe.edu.tr/user/image/13126" },
    { name: "Aslı DOĞRU KOCA", title: "Doç. Dr.", department: "Biyoloji", sub_department: "Botanik", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/adogru", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7082" },
    
    // Ekoloji
    { name: "Çağatay TAVŞANOĞLU", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Ekoloji", is_president: true, avesis_url: "https://avesis.hacettepe.edu.tr/ctavsan", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6202" },
    { name: "Selim Süalp ÇAĞLAR", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Ekoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/sualp", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6238" },
    { name: "Salih Bülent ALTEN", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Ekoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/kaynas", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6161" },
    
    // Genel Biyoloji
    { name: "Mehmet Ali ONUR", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Genel Biyoloji", is_president: true, avesis_url: "https://avesis.hacettepe.edu.tr/mali", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6069" },
    { name: "Ergi Deniz ÖZSOY", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Genel Biyoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/ergideniz.ozsoy", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5857" },
    
    // Hidrobiyoloji
    { name: "Nuray AKBULUT", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Hidrobiyoloji", is_president: true, avesis_url: "https://avesis.hacettepe.edu.tr/emir", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6611" },
    { name: "F. Güler EKMEKÇİ", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Hidrobiyoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/gulere", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7098" },
    
    // Moleküler Biyoloji
    { name: "Hatice MERGEN", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Moleküler Biyoloji", is_president: true, avesis_url: "https://avesis.hacettepe.edu.tr/mergen", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5582" },
    { name: "İ. Çağatay KARAASLAN", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Moleküler Biyoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/cagatayk", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6418" },
    { name: "Işık PERÇİN DEMİRÇELİK", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Moleküler Biyoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/ipercin", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6813" },
    
    // Uygulamalı Biyoloji
    { name: "Osman SERT", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Uygulamalı Biyoloji", is_president: true, avesis_url: "https://avesis.hacettepe.edu.tr/sert", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5444" },
    { name: "Ahmet Murat AYTEKİN", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Uygulamalı Biyoloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/ama", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6356" },
    
    // Zooloji
    { name: "Güldeniz SELMANOĞLU", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Zooloji", is_president: true, avesis_url: "https://avesis.hacettepe.edu.tr/guldeniz", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7384" },
    { name: "Nurhayat BARLAS", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Zooloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/barlas", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7164" },
    { name: "Zafer AYAŞ", title: "Prof. Dr.", department: "Biyoloji", sub_department: "Zooloji", is_president: false, avesis_url: "https://avesis.hacettepe.edu.tr/indiana", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5663" }
  ];

  const subDepartments = useMemo(() => {
    const uniqueSubDepts = [...new Set(biologyFaculty.map(m => m.sub_department))];
    return ['Tümü', ...uniqueSubDepts.sort()];
  }, []);

  const filteredFaculty = useMemo(() => {
    return biologyFaculty
      .filter(member => selectedSubDept === 'Tümü' || member.sub_department === selectedSubDept)
      .filter(member => member.name.toLowerCase().includes(searchTerm.toLowerCase()));
  }, [selectedSubDept, searchTerm]);

  const stats = {
    total: biologyFaculty.length,
    professors: biologyFaculty.filter(m => m.title.includes('Prof')).length,
    subDepartments: subDepartments.length - 1
  };

  const getSubDepartmentIcon = (subDept) => {
    const icons = {
      'Biyoteknoloji': <FlaskConical className="w-5 h-5" />,
      'Botanik': <Leaf className="w-5 h-5" />,
      'Ekoloji': <Globe className="w-5 h-5" />,
      'Genel Biyoloji': <Dna className="w-5 h-5" />,
      'Hidrobiyoloji': <Fish className="w-5 h-5" />,
      'Moleküler Biyoloji': <Microscope className="w-5 h-5" />,
      'Uygulamalı Biyoloji': <Users className="w-5 h-5" />,
      'Zooloji': <Users className="w-5 h-5" />
    };
    return icons[subDept] || <Users className="w-5 h-5" />;
  };

  const FacultyCard = ({ member }) => {
    const [imgError, setImgError] = useState(false);
    const placeholderUrl = `https://ui-avatars.com/api/?name=${member.name.replace(" ", "+")}&background=e2e8f0&color=64748b&font-size=0.4&bold=true`;

    return (
      <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group">
        <div className="p-6">
          <div className="flex flex-col items-center text-center space-y-4">
            <div className="relative">
              <img
                src={imgError || !member.photo_url ? placeholderUrl : member.photo_url}
                alt={member.name}
                className="w-24 h-24 rounded-full object-cover ring-4 ring-gray-200 group-hover:ring-blue-500 transition-all duration-300"
                onError={() => setImgError(true)}
              />
              {member.is_president && (
                <div className="absolute -top-1 -right-1 bg-blue-600 text-white text-xs font-bold px-2 py-1 rounded-full shadow-md">
                  Başkan
                </div>
              )}
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-800">{member.name}</h3>
              <p className="text-gray-500 mb-2">{member.title}</p>
              <div className="flex items-center justify-center space-x-2 text-sm text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
                {getSubDepartmentIcon(member.sub_department)}
                <span className="font-medium">{member.sub_department}</span>
              </div>
            </div>
          </div>
          <div className="mt-6">
            <a
              href={member.avesis_url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-2 w-full bg-blue-500 text-white font-semibold py-2 rounded-lg hover:bg-blue-600 transition-colors duration-300"
            >
              <ExternalLink className="w-4 h-4" />
              <span>AVESİS Profili</span>
            </a>
          </div>
        </div>
      </div>
    );
  };

  return (
    <PageTemplate 
      title="Biyoloji Bölümü" 
      subtitle="Öğretim Üyeleri"
    >
      {/* Navigation Menu */}
      <div className="bg-white shadow-lg rounded-xl mb-8 overflow-hidden">
        <div className="flex flex-wrap">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`flex items-center space-x-3 px-6 py-4 transition-all duration-300 hover:bg-blue-50 ${
                item.isActive 
                  ? 'bg-blue-600 text-white border-b-4 border-blue-800' 
                  : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              <span className={item.isActive ? 'text-white' : 'text-blue-600'}>
                {item.icon}
              </span>
              <span className="font-semibold">{item.name}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-8">
        
        {/* İstatistikler */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl p-6 text-white">
            <div className="flex items-center">
              <Users className="w-10 h-10 mr-4" />
              <div>
                <div className="text-3xl font-bold">{stats.total}</div>
                <div className="text-blue-100">Toplam Öğretim Üyesi</div>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-xl p-6 text-white">
            <div className="flex items-center">
              <Award className="w-10 h-10 mr-4" />
              <div>
                <div className="text-3xl font-bold">{stats.professors}</div>
                <div className="text-green-100">Profesör</div>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl p-6 text-white">
            <div className="flex items-center">
              <Filter className="w-10 h-10 mr-4" />
              <div>
                <div className="text-3xl font-bold">{stats.subDepartments}</div>
                <div className="text-purple-100">Ana Bilim Dalı</div>
              </div>
            </div>
          </div>
        </div>

        {/* Arama ve Filtreleme */}
        <div className="bg-white p-6 rounded-xl shadow-lg">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="relative flex-grow">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="İsme göre ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
              />
            </div>
            <div className="flex flex-wrap gap-2">
              {subDepartments.map(subDept => (
                <button
                  key={subDept}
                  onClick={() => setSelectedSubDept(subDept)}
                  className={`flex items-center space-x-2 px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 ${
                    selectedSubDept === subDept 
                      ? 'bg-blue-500 text-white shadow' 
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {subDept !== 'Tümü' && getSubDepartmentIcon(subDept)}
                  <span>{subDept}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Öğretim Üyeleri Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredFaculty.map((member, index) => (
            <FacultyCard key={index} member={member} />
          ))}
        </div>

        {filteredFaculty.length === 0 && (
          <div className="text-center py-12">
            <Users className="w-16 h-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">Öğretim üyesi bulunamadı</h3>
            <p className="text-gray-500">Arama kriterlerinizi değiştirmeyi deneyin.</p>
          </div>
        )}

      </div>
    </PageTemplate>
  );
};

export default BiologyFaculty; 